import { useState } from "react";
import { useParams } from "react-router";
import { IconPlayerPlayFilled } from "@tabler/icons-react";
import { AnalyticsApi } from "@/lib/api/analytics-api";
import { DFY_PACKAGE_IMAGE_COUNTS } from "@repo/api/utils/dfy-billing";
import {
  DFY_ADD_ON_CONTENT,
  DFY_PACKAGE_CONTENT,
  DfyPackageExample,
} from "../dfy-order-form-content";

export default function DfyExampleVideo({
  example,
  source,
}: {
  example: DfyPackageExample;
  source: "HOME" | "DFY_ORDER_FORM";
}) {
  const { teamExternalId } = useParams();
  const [hasStarted, setHasStarted] = useState(false);

  const play = () => {
    setHasStarted(true);
    AnalyticsApi.logDfyExamplePlayed(
      {
        exampleId: example.vimeoId,
        packageType: example.type,
        addOn: example.addOn,
        source,
      },
      teamExternalId,
    );
  };
  const packageName = DFY_PACKAGE_CONTENT.find(
    (option) => option.id === example.type,
  )?.name;
  const addOnName = DFY_ADD_ON_CONTENT.find(
    (option) => option.id === example.addOn,
  )?.name;

  return (
    <div className="relative aspect-video overflow-hidden rounded-2xl bg-black shadow-lg">
      {hasStarted ? (
        <iframe
          src={`https://player.vimeo.com/video/${example.vimeoId}?autoplay=1&badge=0&title=0&byline=0&portrait=0&pip=0&airplay=0&chromecast=0&quality_selector=0&speed=0&volume=0&vimeo_logo=0&cc=0&transcript=0&like=0&watch_later=0&share=0`}
          title={packageName}
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          className="absolute inset-0 h-full w-full"
        />
      ) : (
        <button
          type="button"
          onClick={play}
          className="group absolute inset-0 cursor-pointer"
        >
          <img
            src={example.thumbnail}
            alt=""
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 group-hover:scale-103"
          />
          <span className="absolute inset-0 flex items-end bg-linear-to-t from-black/80 via-black/20 via-50% to-transparent p-4 text-left sm:p-5">
            <span className="flex items-center gap-3">
              <span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-white text-black shadow-lg sm:size-10">
                <IconPlayerPlayFilled className="size-4" />
              </span>
              <span className="flex flex-col text-sm leading-snug">
                <span className="font-semibold text-white">{packageName}</span>
                <span className="text-white/80">
                  {DFY_PACKAGE_IMAGE_COUNTS[example.type]} images
                  {addOnName && ` + ${addOnName} add-on`}
                </span>
              </span>
            </span>
          </span>
        </button>
      )}
    </div>
  );
}
